module.exports = __webpack_public_path__ + "static/media/Repeat_Payment.f1641cb2.svg";